import { Icon } from '@/components/ui/Icon';
import { useApp } from '@/lib/context';
import { getRoleLabel } from '@/lib/roles';
import { useUI } from '@/lib/uiContext';
import { useAuth0 } from '@auth0/auth0-react';
import { mdiAccount, mdiLogout, mdiMagnify, mdiMenu } from '@mdi/js';
import * as React from 'react';

export const Navbar: React.FC = () => {
  const { user, logout } = useAuth0();
  const { currentUser } = useApp();
  const { toggleSidebar, openCommandPalette } = useUI();

  const userRole = React.useMemo(() => {
    if (!currentUser?.roles?.length) return null;
    return getRoleLabel(currentUser.roles[0]);
  }, [currentUser?.roles]);

  const handleMenuToggle = () => {
    toggleSidebar();
  };

  return (
    <header className='h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6'>
      {/* Left side */}
      <div className='flex items-center space-x-4'>
        <button
          onClick={handleMenuToggle}
          className='lg:hidden inline-flex items-center justify-center p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 rounded-sm transition-colors'
        >
          <Icon path={mdiMenu} size={24} />
        </button>

        <div className='hidden lg:block'>
          <h1 className='text-2xl font-semibold text-gray-900'>Dashboard</h1>
        </div>
      </div>

      {/* Right side */}
      <div className='flex items-center space-x-4'>
        {/* Quick search */}
        <button
          onClick={openCommandPalette}
          className='flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors'
          title='Open command palette (⌘K)'
        >
          <Icon path={mdiMagnify} size={16} />
          <span className='hidden sm:inline'>Search...</span>
          <span className='hidden sm:inline text-xs text-gray-400'>⌘K</span>
        </button>

        {/* User menu */}
        <div className='flex items-center space-x-2'>
          {user && (
            <>
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className='w-8 h-8 rounded-full'
                />
              ) : (
                <div className='w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center'>
                  <Icon path={mdiAccount} size={18} className='text-gray-500' />
                </div>
              )}
              <div className='hidden lg:block'>
                <p className='text-sm font-medium text-gray-900'>
                  {user.email}
                </p>
                {userRole && (
                  <p className='text-xs text-gray-500'>{userRole}</p>
                )}
              </div>
            </>
          )}

          <button
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
            className='inline-flex items-center justify-center p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 rounded-sm transition-colors'
            title='Logout'
          >
            <Icon path={mdiLogout} size={18} />
          </button>
        </div>
      </div>
    </header>
  );
};
